import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import HeroSection from './components/sections/HeroSection';
import SupportSection from './components/sections/SupportSection';
import ContactSection from './components/sections/ContactSection';
import PrivacySection from './components/sections/PrivacySection';
import { NAVIGATION_TABS } from './utils/constants';
import styles from './App.module.css';

function App() {
  return (
    <BrowserRouter>
      <div className={styles.app}>
        <Header tabs={NAVIGATION_TABS} />

        <main className={styles.main}>
          <Routes>
            <Route path="/" element={<HeroSection />} />
            <Route path="/support" element={<SupportSection />} />
            <Route path="/contact" element={<ContactSection />} />
            <Route path="/privacy" element={<PrivacySection />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
